<div class="page-title-container {{project}}">
  <div class="container">
    <div class="content">
      <div class="title" *ngIf="title">
        <kion-headline-tag
          [titleSize]="title.titleSize"
          [title]="title.title"
        ></kion-headline-tag>
      </div>
      <div class="description" *ngIf="description">
        <markdown [data]="description"></markdown>
      </div>
    </div>
  </div>
</div>
<svg class="tilt {{ project }}" viewBox="0 0 200 7" >
  <path fill="red" d="M 0,0 L 0,7 L 200,0 Z" />
</svg>
